<template>
    <BreadCrumb PageTitle="Liste des approvisionnrements" />
    <ListeApprovisionnement />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeApprovisionnement from "../../components/Approvisionnement/ListeApprovisionnement.vue";

    export default defineComponent({
        name: "ListeApprovisionnementPage",
        components: {
            BreadCrumb,
            ListeApprovisionnement,
        },
    });
</script>